import * as yup from 'yup';
import { SuggestionSchema } from '../../../common';

// Validation Schema for the Nursing Report Form
export const NursingReportFormSchema = yup.object({
  dateAndTime: yup
    .date()
    .required()
    .default(() => new Date()),
  topic: yup.string().nullable().optional(),
  observation: yup.string().required(),
  measures: yup.string().nullable().optional(),
});

// Validation Schema for Creating a Nursing Report Form
export const CreateNursingReportFormSchema = yup
  .object({
    residentId: yup.string().required(),
  })
  .concat(NursingReportFormSchema);

// Validation Schema for Updating a Nursing Report Form
export const UpdateNursingReportFormSchema = yup
  .object({
    id: yup.string().required(),
    residentId: yup.string().required(),
  })
  .concat(NursingReportFormSchema);

export type INursingReportForm = yup.InferType<typeof NursingReportFormSchema>;

export type ICreateNursingReportForm = yup.InferType<typeof CreateNursingReportFormSchema>;

export type IUpdateNursingReportForm = yup.InferType<typeof UpdateNursingReportFormSchema>;

export const NursingReportSuggestionSchema = yup.object({
  topic: SuggestionSchema.nullable(),
});

export type INursingReportSuggestion = yup.InferType<typeof NursingReportSuggestionSchema>;
